import { call, takeLatest, put } from 'redux-saga/effects';
import { getStartedPageRequest, getStartedPageSuccess, getStartedPageFailure } from '../actions/getStartedAction';
import { makeGetStartedFormSubmitCall } from '../../api/getStartedAPI';

export function* getStartedPage(action) {
	try {
		const response = yield call(makeGetStartedFormSubmitCall, action.payload);
		yield put(getStartedPageSuccess(response));
	} catch (error) {
		yield put(getStartedPageFailure(error));
	}
}
 
function* getStartedPageSaga() {
	yield takeLatest( getStartedPageRequest, getStartedPage );
}
 
export default getStartedPageSaga;
